import { createSlice } from '@reduxjs/toolkit';
import { Notification } from 'components/CustomNotification';
import {
  ActivityPostList,
  AddActivityPost,
  UpdateActivityPost,
  GetPostById,
  DeletePost,
  getRelationStatus,
  onChangeBlock,
  onChangeMute,
  onChangeSave,
  OnchangeFollowerRequest,
  FollowersRequestList,
  PostSavedList,
  OnchangeFollowerRequestAccept,
  getNetworkList,
  FollowerSuggestionsList,
  onChangeSaveDelete,
  onChangeRemoveOrUnFollow,
  ActivityByUserPostsList,
  onChangeWithdrawRequest,
  FollowRequestList,
  ActivityBySearchPostsList,
  AuthActivityPostList,
} from '../services/ActivityPostService';
import axios from 'components/Axios';
import { CurrentProfile } from 'redux/APIEndPoint';

export const PostActivitySlice = createSlice({
  name: 'dropdown',
  initialState: {
    activityList: {},
    singlePost: '',
    updateActivities: '',
    relationStates: {
      isAccepted: false,
      isMuted: false,
      isBlocked: false,
    },
    PostMessage: '',
  },
  reducers: {
    activityList: (state, action) => {
      state.activityList = action.payload;
    },
    singlePost: (state, action) => {
      state.singlePost = action.payload;
    },
    updateActivities: (state, action) => {
      state.updateActivities = action.payload;
    },
    updateRelations: (state, action) => {
      state.relationStates = action.payload.data;
    },
    PostMessageReceive: (state, action) => {
      state.PostMessage = action.payload.data;
    },
  },
});

export const InsertActivityPost = (data) => async () => {
  const formData = new FormData();
  if (data?.image.length > 0) {
    data.image.forEach((item) => {
      formData.append('images', item || '');
    });
  } else {
    formData.append('images', '');
  }

  if (data?.document) {
    formData.append('documents', data?.documentSrc || '');
  } else {
    formData.append('documents', '');
  }
  formData.append('video', data.video[0] || '');
  formData.append('description', data.comment || '');
  formData.append('type', data?.image.length > 0 ? 1 : data.video[0] ? 2 : data?.documentSrc ? 3 : 0);
  formData.append('createdById', data.userid);
  formData.append('longitude', data.longitude);
  formData.append('latitude', data.latitude);
  formData.append('comment', data.isComment);
  formData.append('mentionInfo', JSON.stringify(data.mentionInfo));
  formData.append('categoryId', data.categoryId);
  formData.append('clientOffSet', new Date().getTimezoneOffset());
  formData.append('country', data.country || '')

  return AddActivityPost(formData)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
      return err.response?.data;
    });
};

export const InsertNewActivityPost = (data) => async (dispatch, getState) => {
  if (location.pathname === '/following') {
    const state = getState();
    const list = state?.PostActivitySlice?.activityList?.rows?.data || [];
    const newPost = {
      ...state?.PostActivitySlice?.activityList,
      rows: {
        data: [data, ...list],
      },
    };
    dispatch(activityList(newPost));
  }
};

export const UpdatePost = (data) => async (dispatch, getState) => {
  const state = getState();
  const list = [...state?.PostActivitySlice?.activityList?.rows?.data];
  const listIndex = list.findIndex((item) => item.id === data.id);
  if (listIndex !== undefined && list?.length > 0) {
    list[listIndex] = data;
  }
  const newPost = {
    ...state?.PostActivitySlice?.activityList,
    rows: {
      data: list,
    },
  };
  dispatch(activityList(newPost));
};

export const getActivityPostList =
  (userId, currentTime, page, size, country) => async (dispatch, getState) => {
    return ActivityPostList(userId, currentTime, page, size, country)
      .then((response) => {
        const state = getState();
        const list = state?.PostActivitySlice?.activityList?.rows?.data;
        let concatRes = {};
        if (list?.length > 0) {
          concatRes = {
            ...response.data,
            rows: {
              data: [...list, ...response.data.rows.data],
            },
          };
        } else {
          concatRes = response.data;
        }
        dispatch(activityList(concatRes));
        return response.data;
      })
      .catch((err) => {
        console.warn(err.response?.data?.message);
        return err.response?.data;
      });
  };

export const getAuthActivityPostList =
  (currentTime, page, size, country) => async (dispatch, getState) => {
    return AuthActivityPostList(currentTime, page, size, country)
      .then((response) => {
        const state = getState();
        const list = state?.PostActivitySlice?.activityList?.rows?.data;
        let concatRes = {};
        if (list?.length > 0) {
          concatRes = {
            ...response.data,
            rows: {
              data: [...list, ...response.data.rows.data],
            },
          };
        } else {
          concatRes = response.data;
        }
        dispatch(activityList(concatRes));
        return response.data;
      })
      .catch((err) => {
        console.warn(err.response?.data?.message);
        return err.response?.data;
      });
  };

export const getFollowersSuggestionsList = (page, size) => async () => {
  return FollowerSuggestionsList(page, size);
};

export const getFollowersList = (type, page, size) => async () => {
  return getNetworkList(type, page, size);
};

export const UpdateActivityPostList = (data, id) => async () => {
  const payload = {
    type: data.type,
    description: data.comment,
    comment: data.isComment,
    clientOffSet: new Date().getTimezoneOffset(),
  };
  return UpdateActivityPost(payload, id);
};

export const getActivityPostByid = (data) => async (dispatch) => {
  GetPostById(data).then((response) => {
    dispatch(singlePost(response.data));
  });
};

export const resetActivityPostByid = () => async (dispatch) => {
  dispatch(singlePost(''));
};

export const getActivityByUserPostsList =
  (page, size) => async (dispatch, getState) => {
    ActivityByUserPostsList(page, size)
      .then((response) => {
        const state = getState();
        const list = state?.PostActivitySlice?.activityList?.rows?.data;
        let concatRes = {};
        if (list?.length > 0) {
          concatRes = {
            ...response.data,
            rows: {
              data: [...list, ...response.data.rows.data],
            },
          };
        } else {
          concatRes = response.data;
        }
        dispatch(activityList(concatRes));
        return response.data;
      })
      .catch((err) => {
        console.warn(err.response?.data?.message);
        return err.response?.data;
      });
    // .then((response) => {
    //   dispatch(activityList(response.data));
    // });
  };

export const getSearchPostsList =
  (keyword, page, size) => async (dispatch, getState) => {
    return ActivityBySearchPostsList(keyword, page, size)
      .then((response) => {
        const state = getState();
        const list = state?.PostActivitySlice?.activityList?.rows?.data;
        let concatRes = {};
        if (list?.length > 0) {
          concatRes = {
            ...response.data,
            rows: {
              data: [...list, ...response.data.rows.data],
            },
          };
        } else {
          concatRes = response.data;
        }
        dispatch(activityList(concatRes));
        return response.data;
      })
      .catch((err) => {
        console.warn(err.response?.data?.message);
        return err.response?.data;
      });
  };

export const deleteActivityPost =
  (data, attachment) => async (dispatch, getState) => {
    return DeletePost(data, attachment)
      .then((response) => {
        const state = getState();
        const list = state?.PostActivitySlice?.activityList?.rows?.data;
        const concatRes = {
          ...response.data,
          rows: {
            data: list?.filter((item) => item?.id !== data),
          },
        };
        dispatch(activityList(concatRes));
        return response.data;
      })
      .catch((err) => {
        Notification('warning', err.response?.data?.message);
        return err.response?.data;
      });
  };

export const ResetPostList = () => async (dispatch) => {
  dispatch(activityList({}));
};

export const {
  activityList,
  updateActivities,
  singlePost,
  updateRelations,
  PostMessageReceive,
} = PostActivitySlice.actions;
export default PostActivitySlice.reducer;

export const getPostRelationReq = (obj) => async (dispatch) => {
  try {
    const { data } = await getRelationStatus(obj);
    dispatch(updateRelations(data));
  } catch (error) {
    Notification('warning', error.response?.data?.message);
  }
};

export const getFollowersRequest = (userId, page, size) => async () => {
  return FollowersRequestList(userId, page, size);
  // .then((response) => {
  //   dispatch(activityList(response.data));
  // });
};

export const getFollowRequest = (userId, page, size) => async () => {
  return FollowRequestList(userId, page, size);
};

export const getSavedPostList =
  (page, size, url) => async (dispatch, getState) => {
    PostSavedList(page, size, url)
      .then((response) => {
        const state = getState();
        const list = state?.PostActivitySlice?.activityList?.rows?.data;
        let concatRes = {};
        if (list?.length > 0) {
          concatRes = {
            ...response.data,
            rows: {
              data: [...list, ...response.data.rows.data],
            },
          };
        } else {
          concatRes = response.data;
        }
        dispatch(activityList(concatRes));
        return response.data;
      })
      .catch((err) => {
        console.warn(err.response?.data?.message);
        return err.response?.data;
      });
    // .then((response) => {
    //   dispatch(activityList(response.data));
    // });
  };

export const changePostRelations = (data, callGet) => async (dispatch) => {
  try {
    switch (data.key) {
      case 'SAVE':
        await onChangeSave(data)
          .then((res) => {
            res.data.type = 'SAVE';
            res.data.data = data;
            Notification('success', res?.data?.message);
            dispatch(PostMessageReceive(res));
          })
          .catch((err) => {
            Notification('error', err.response?.data?.message);
            dispatch(PostMessageReceive(err));
          });
        break;
      case 'UNSAVE':
        await onChangeSaveDelete(data)
          .then((res) => {
            res.data.type = 'UNSAVE';
            res.data.data = data;
            Notification('success', res?.data?.message);
            dispatch(PostMessageReceive(res));
          })
          .catch((err) => {
            Notification('error', err.response?.data?.message);
            dispatch(PostMessageReceive(err));
          });
        break;
      case 'BLOCK':
        await onChangeBlock(data)
          .then((res) => {
            if (!res?.data.status) {
              Notification('warning', res?.data?.message);
            } else {
              res.data.type = 'BLOCK';
              Notification('success', res?.data?.message);
            }
            dispatch(PostMessageReceive(res));
          })
          .catch((err) => {
            Notification('error', err.response?.data?.message);
            dispatch(PostMessageReceive(err));
          });
        break;
      case 'MUTE':
        await onChangeMute(data)
          .then((res) => {
            if (!res?.data.status) {
              Notification('warning', res?.data?.message);
            } else {
              res.data.type = 'MUTE';
              Notification('success', res?.data?.message);
            }
            dispatch(PostMessageReceive(res));
          })
          .catch((err) => {
            Notification('error', err.response?.data?.message);
            dispatch(PostMessageReceive(err));
          });
        break;
      case 'FOLLOW':
        await OnchangeFollowerRequest(data)
          .then((res) => {
            if (!res?.data.status) {
              Notification('warning', res?.data?.message);
            } else {
              res.data.type = 'FOLLOW';
              Notification('success', res.data?.message);
            }
            dispatch(PostMessageReceive(res));
          })
          .catch((err) => {
            Notification('error', err.response?.data?.message);
            dispatch(PostMessageReceive(err));
          });
        break;
      case 'FOLLOW REQUEST':
        await OnchangeFollowerRequestAccept(data)
          .then((res) => {
            if (!res?.data.status) {
              Notification('warning', res?.data?.message);
            } else {
              res.data.type = 'FOLLOW REQUEST';
              Notification('success', res?.data?.message);
            }
            dispatch(PostMessageReceive(res));
          })
          .catch((err) => {
            Notification('error', err.response?.data?.message);
            dispatch(PostMessageReceive(err));
          });
        break;
      case 'WITHDRAW':
        await onChangeWithdrawRequest(data)
          .then((res) => {
            if (!res?.data.status) {
              Notification('warning', res?.data?.message);
            } else {
              res.data.type = 'WITHDRAW';
              Notification('success', res?.data?.message);
            }
            dispatch(PostMessageReceive(res));
          })
          .catch((err) => {
            Notification('error', err.response?.data?.message);
            dispatch(PostMessageReceive(err));
          });
        break;
      case 'UNFOLLOW':
        await onChangeRemoveOrUnFollow(data)
          .then((res) => {
            if (!res?.data.status) {
              Notification('warning', res?.data?.message);
            } else {
              res.data.type = data?.submitKey || 'UNFOLLOW';
              Notification('success', res?.data?.message);
            }
            dispatch(PostMessageReceive(res));
          })
          .catch((err) => {
            Notification('error', err.response?.data?.message);
            dispatch(PostMessageReceive(err));
          });
        break;
      default:
        break;
    }
  } catch (error) {
    Notification('error', error.response?.data?.message);
  } finally {
    if (callGet === 'callGet' && data.key !== 'SAVE' && data.key !== 'UNSAVE') {
      dispatch(
        getPostRelationReq({ followerId: data.followerId, userId: data.userId })
      );
    }
    // dispatch(PostMessageReceive(""));
    // data.key !== 'FOLLOW REQUEST' &&
    // dispatch(getPostRelationReq({ followerId: data.followerId }));
  }
};

export const getActivityProfileByuserName = (username) => async () => {
  return await axios.get(`${CurrentProfile}/${username}`);
};
